// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__-uA9r","sub_container":"Loading_sub_container__trAnt"};